module.exports = "data:image/svg+xml;base64,PHN2ZyBpZD0iQ2FscXVlXzEiIGRhdGEtbmFtZT0iQ2FscXVlIDEiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIgdmlld0JveD0iMCAwIDE4IDE4Ij48ZGVmcz48c3R5bGU+LmNscy0xe2ZpbGw6bm9uZTtzdHJva2U6I2ZmZjtzdHJva2UtbWl0ZXJsaW1pdDoxMDt9PC9zdHlsZT48L2RlZnM+PHRpdGxlPmNsb3NlLW1vdHM8L3RpdGxlPjxsaW5lIGNsYXNzPSJjbHMtMSIgeDE9IjE4IiB5Mj0iMTgiLz48bGluZSBjbGFzcz0iY2xzLTEiIHgxPSIxOCIgeTE9IjE4Ii8+PC9zdmc+"


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/close-mots.svg
// module id = pa3T
// module chunks = 1